import React, { useEffect, useState } from "react";
import { List, Modal, Skeleton, Button, Popconfirm } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useLazyGetWorkOrdersNotificationsQuery , 
    useMarkAsReadMutation 
} 
    from "../../../../store/services/api/notifications-api";
import { humanizeEnum } from "../../../../utils/humanizers";
import { WorkOrderStatus, WorkOrderType } from "../../../../store/data/entities/work-order";
import {useNavigation} from "@react-navigation/native";
import { Portal } from "react-native-paper";

interface UserNotificationsModalProps {
  userId: string;
  onClose: () => void;
  visible: boolean;
}

export default function UserNotificationsModal({
  userId,
  visible,
  onClose,
}: UserNotificationsModalProps) {

  const [getNotifications, { data, isFetching }] = useLazyGetWorkOrdersNotificationsQuery();
   const [markAsRead] = useMarkAsReadMutation();

  useEffect(() => {
    if (visible) {
      getNotifications({ userId });
    }
  }, [onClose, visible, userId, getNotifications]);

  const handleMarkAsRead = async (notificationId: string) => {
    try {
       await markAsRead({ notificationId }).unwrap();

      getNotifications({ userId });
    } catch (err) {
      console.error("Failed to mark notification as read", err);
    }
  };

  const navigation = useNavigation<any>();
  const navigateToEdit = (id: string) => navigation.replace("workOrders", { 
    screen: "recordView", 
    params: { id}
  });


  const navigateToApprove = (id: string) => 
  navigation.replace("workOrders", { 
    screen: "manage", 
    params: { id, approval: true }
  });

  return (
    <>
      <Portal>
        <Modal
          width={800}
        centered
        title="Unread Notifications"
        open={visible}
        onCancel={onClose}
        onOk={onClose}
        destroyOnClose
        footer={null}

      >
        <Skeleton loading={isFetching} active>
            <h3>Work Orders</h3>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2, textAlign: "center" }}>Mark as Read</div>
            <div style={{ flex: 2 }}>Description</div>
            <div style={{ flex: 2 }}>Work Order Reference</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            <div style={{ flex: 2 }}>View Work Order</div>
            
            
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2, textAlign: "center" }}>
                  <Popconfirm
                    title="Mark this notification as read?"
                    onConfirm={() => handleMarkAsRead(item.notificationId)}
                  >
                    <Button type="link" icon={<CheckOutlined />} />
                  </Popconfirm>
                </div>
                <div style={{ flex: 2 }}>{item.description}</div>
                <div style={{ flex: 2 }}>{item.reference}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
                <div style={{ flex: 2, textAlign: "right" }}>
                    <Popconfirm
                    title="Are you sure you want to view this work order?"
                    onConfirm={() => item.status === WorkOrderStatus.PendingApproval ? navigateToApprove(item.id) : navigateToEdit(item.id)}
                    >
                        <Button
                        type="link"
                        >
                        View Work Order
                        </Button>

                    </Popconfirm>
                    
                </div>
                
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
      </Portal>

      
    </>
  );
}
